<template lang="pug">
.follower-send-message-history-table-component
  // テーブル
  b-table(
    :items="_value"
    :fields="fields"
    :current-page="currentPage"
    :per-page="perPage"
    :filter="filter"
    :busy="isLoading"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
    :filter-function="filterTable"
    @filtered="onFiltered"
  )
    // ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中...
    // レコード無し
    template(#empty)
      .empty-message
        span 情報がありません
    // フィルター後レコード無し
    template(#emptyfiltered)
      .empty-message
        span 情報がありません

    // セル：日時
    template(#cell(datetime)="row")
      span {{ convertDatetime(row.item.datetime) }}
    // セル：タイトル
    template(#cell(title)="row")
      .overflow-hidden.title-text(:id="`title-${row.item.datetime}`") {{ row.item.title }}
      b-popover(v-if="row.item.title" :target="`title-${row.item.datetime}`" triggers="hover")
        .d-flex.flex-column
          span {{ `${row.item.title}` }}
    // セル：内容
    template(#cell(text)="row")
      .overflow-hidden.title-text(:id="`text-${row.item.datetime}`") {{ row.item.text }}
      b-popover(v-if="row.item.text" :target="`text-${row.item.datetime}`" triggers="hover")
        .d-flex.flex-column
          span {{ `${row.item.text}` }}
    // セル：添付ファイル
    template(#cell(files)="row")
      button.btn.file-confirm-btn(v-if="0 < row.item.files.length" @click="onFileConfirm(row.item)") 確認
      span(v-else) 無し
    // セル：送信人数
    template(#cell(sendCount)="row")
      span {{ row.item.sendCount }}人
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { FollowerMessagesGetModel } from "@/commons/services/FollowerMessages";

/**
 * ### フォロワーメッセージ履歴テーブル
 */
@Component({})
export default class SendMessageHistoryTable extends Vue {
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<SendMessageHistoryTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<SendMessageHistoryTableField>;
  /** 全体行数 */
  @Prop({ required: true })
  totalRows!: number;
  /** 現在のページ */
  @Prop({ required: true })
  currentPage!: number;
  /** 1ページあたりの表示行数 */
  @Prop({ required: true })
  perPage!: number;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isLoading!: boolean;
  /** フィルター */
  @Prop()
  filter!: FilterSetting;

  get _value(): Array<SendMessageHistoryTableItem> {
    return this.value;
  }

  /**
   * ### 日付を文字列に変換する
   */
  public convertDatetime(datetime: number): string {
    return this.$dateUtil.convertNumberToString(datetime, "yyyy年mm月dd日 hh:MM");
  }

  /**
   * ### フィルタリング
   */
  public filterTable(item: SendMessageHistoryTableItem, filter: FilterSetting): boolean {
    return this.filterWriterId(item, filter) && this.filterSearchWords(item, filter);
  }

  /**
   * ### 記載者フィルタリング
   */
  public filterWriterId(item: SendMessageHistoryTableItem, filter: FilterSetting): boolean {
    if (filter.writerId == "") {
      return true;
    }

    if (item.userId == filter.writerId) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * ### 検索ワード検索
   *
   * - 以下で検索する
   *   - タイトル
   *   - 本文
   */
  public filterSearchWords(item: SendMessageHistoryTableItem, filter: FilterSetting): boolean {
    if (filter.searchWord == "") {
      return true;
    }

    const words: string[] = this.$filterUtil.createSearchWord(filter.searchWord);

    let foundTitle: boolean = true;
    let foundText: boolean = true;

    for (const word of words) {
      if (item.title.indexOf(word) == -1) {
        foundTitle = false;
      }
      if (item.text.indexOf(word) == -1) {
        foundText = false;
      }
    }

    return foundTitle || foundText;
  }

  /**
   * ### フィルタリングイベント
   */
  public onFiltered(filteredItems: any) {
    this.$emit("update:totalRows", filteredItems.length);
    return;
  }

  /**
   * ### 添付ファイルの確認ボタン押下イベント
   */
  public onFileConfirm(item: SendMessageHistoryTableItem): void {
    this.$emit("onFileConfirm", item);
    return;
  }
}

/** テーブルの列名の情報 */
export interface SendMessageHistoryTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface SendMessageHistoryTableItem extends FollowerMessagesGetModel {
  /** 送信人数 */
  sendCount: number;
}

export interface FilterSetting {
  writerId: string;
  searchWord: string;
}
</script>

<style lang="scss" scoped>
.follower-send-message-history-table-component {
  // 文字がtd要素の幅をはみ出した場合「…」で隠すスタイル
  .overflow-hidden {
    overflow: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .detail-btn {
    width: 64px;
  }
}
</style>
